import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { DatePipe } from '@angular/common'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';

import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
//import { Script } from 'vm';


import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';

interface Appointment {
  fullName: string;
  timeIn: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
   
 }


@Component({
  selector: 'app-appointment-edit',
  templateUrl: './appointment-edit.component.html',
  styleUrls: ['./appointment-edit.component.css']
})
export class AppointmentEditComponent implements OnInit {

heardAbout;
  

    
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 
 color;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ appointment: Appointment }>[]>;
  activeDayIsOpen: boolean = false;
selectedDate;

  loading=false;
  appointmentForm:FormGroup;
date;
  userappointment=[];
  error:any = '';
  success = '';
  branchs=[];
  salesRep=[];

  branch;

  branchselected=false;
questionaireForm:FormGroup;

loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;
currentUser:User;
role;
username;

  validationMessages = {
    'fullName': {
      'required': 'Full Name is required'
    },
    'phoneNumber': {
      'required': 'Phone Number is required'
    },
  
    'email': {
      'required': 'Email is required',
      'pattern' : 'Please enter a valid email'
    },
 
  //'whatLoveProduct': {
   // 'required': 'required'
  //},
  'status': {
    'required': 'required'
  }
  
  };
  
  
  formErrors = {
    'fullName': '',
    'phoneNumber': '',
    'email': '',
    'status': ''
  }
  

  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _http: HttpClient,
    private actroute: ActivatedRoute,
    private _appointment: AppointmentService,
    private _authenticationService: AuthenticationService,
    public datepipe: DatePipe) {

      
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
     }

  ngOnInit(): void {
   // this.fetchEvents();
    this.getAllBranchs();
    this.loading=false;


    this.appointmentForm = this.fb.group({
      pid: new FormControl(''),
      clientID: new FormControl(''),
       fullName: new FormControl('', [Validators.required]),
       phoneNumber: new FormControl('',),
       email: new FormControl(''),
       branch: new FormControl('',[Validators.required]),
       personCount: new FormControl(''),
       clientele: new FormControl(''),
       ageGroup: new FormControl(''),
       companyName: new FormControl(''),
       describesYou: new FormControl(''),
       lookingFor: new FormControl(''),
       heardAboutUs: new FormControl(''),
       workWithFabricator: new FormControl(''),
       covid: new FormControl(''),
       webLink: new FormControl(''),
       oldtimeIn: new FormControl(''),
       timeIn: new FormControl(''),
       timeOut: new FormControl(''),
       oldSalesRepID: new FormControl(''),
       salesRepID: new FormControl(''),
       requestType: new FormControl(''),
       status: new FormControl(''),
       tag: new FormControl(''),
       notes: new FormControl(''),
       modifiedBy: new FormControl(this.loggedInUserId),
     });
    
    //actroute from tangibleasset
this.actroute.paramMap.subscribe(params => {
  // This is never executed, for route is not recognized
  // let myArray=params.getAll('extra');
  const pid = params.get('extra')
  const fullName = params.get('extra1')
  const phoneNumber = params.get('extra2')
  const branch = params.get('extra3');
  const timeIn = params.get('extra4');
  //console.log(pid);
  if (pid) {
   // console.log(fullName);
    this.getAppointmentToEdit(pid, fullName,phoneNumber,branch,timeIn);
    this. getSalesRep(branch);
  //  this.viewMode = true;
  } else {
    //this.viewMode = false;
   // console.log('done');
  }
});


  }




  onSubmit(){
    
    this.logValidationErrors(this.appointmentForm );
   
this.loading=true;

 //  console.log(this.appointmentForm.value);
         this._appointment.updateAppointment(this.appointmentForm.value)
      .subscribe(//subscribe to Observable
        response => {console.log('Success!', response);
        this.success=response['SUCCESS'];
        this.appointmentForm.reset;        
        document.getElementById("openSuccessModalButton").click();
      },
        error => {console.error('Error!', error);
        this.error=error.error.text ;
      }       
      );
  
          }



          getAppointmentToEdit(pid, fullName,phoneNumber,branch,timeIn) {
     
             this._appointment.getUserAppointment(pid,fullName,phoneNumber,branch,timeIn).subscribe(
              response =>  {
                this.userappointment= response;

                console.log(this.userappointment);
                this.patchappointmentForm();
              },
              (err) => {
                this.error = err;
              }
            );
          
          }

          

          getSalesRep(branch){
          //  console.log(branch);
            if (branch != "None" || branch!="") {
              this._appointment.getSalesRepByBranch(branch).subscribe(
                (res) => {
                  this.salesRep = res;
                //  console.log(this.salesRep);
                  this.branchselected = true;
               
                }
                ,
                (err) => {
                  this.error = err;
                }
              );
            }
            else {
              this.branchselected = true;
            }
        

          }

          patchappointmentForm(){
           // this.branchselected = true;
        //  /   this. getSalesRep(this.userappointment[0].branch);
if(this.userappointment[0].salesRepID==null || this.userappointment[0].salesRepID==""){
  this.userappointment[0].salesRepID="";
}
var heard=this.userappointment[0].heardAboutUs;
if(heard!='Drive By' && heard!='Designer' && heard!='Contractor' && heard!='Fabricator' && heard!='Family/Friends' && heard!='Social Media' && heard!=''){
        this.heardAbout='Other';
}
            this.appointmentForm.patchValue({
              // departmentId: assetformmodel[0].department,
               pid: this.userappointment[0].pid,
               clientID:this.userappointment[0].clientID,
               fullName: this.userappointment[0].fullName,
               email: this.userappointment[0].email,
               phoneNumber: this.userappointment[0].phoneNumber,
               branch: this.userappointment[0].branch,
               ageGroup: this.userappointment[0].ageGroup,
               companyName: this.userappointment[0].companyName,
               describesYou: this.userappointment[0].describesYou,
               lookingFor: this.userappointment[0].lookingFor,
               heardAboutUs: this.userappointment[0].heardAboutUs,
               workWithFabricator: this.userappointment[0].workWithFabricator,
               covid: this.userappointment[0].covid,
               webLink: this.userappointment[0].webLink,
               oldtimeIn: this.userappointment[0].timeIn,
               timeIn: this.datepipe.transform(this.userappointment[0].timeIn, 'yyyy-MM-dd h:mm a'),
              
               timeOut: this.userappointment[0].timeOut,
               
               clientele: this.userappointment[0].clientele,
               oldSalesRepID: this.userappointment[0].salesRepID,
               salesRepID: this.userappointment[0].salesRepID,
               personCount: this.userappointment[0].personCount,
               requestType: this.userappointment[0].requestType,
               dateSubmitted: this.userappointment[0].dateSubmitted,
               tag: this.userappointment[0].tag,
               status: this.userappointment[0].status,
               notes: this.userappointment[0].notes,
               
               

           
             });
             console.log(this.datepipe.transform(this.userappointment[0].timeIn, 'yyyy-MM-dd h:mm a'));
          }


          patchCheckIn(){
            let dateTime = new Date();
            this.date=new Date();
 let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

            this.appointmentForm.patchValue({
              timeIn:latest_date
            });
          }



          patchCheckOut(){
            let dateTime = new Date();
            this.date=new Date();
 let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

            this.appointmentForm.patchValue({
              timeOut:latest_date
            });
          }





          
  getAllBranchs(){
    this._appointment.getAllBranchs().subscribe(
      (res) => {

        this.branchs = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }

  backClicked() {
    this._location.back();
  }



  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
            //  console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }





  







 /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
      console.log(results);
      return results.map((appointment: Appointment) => {
        this.colorForRep(appointment.salesRep);
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
        return {
         
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+appointment.salesRep,
          start: new Date(
            appointment.timeIn
          ),
          
          color:this.color,
         // cssClass: main-dashboard.component.css,
          meta: {
            appointment,
          },

        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ appointment: Appointment }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  console.log(event.meta.appointment);
  if(event.meta.appointment.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.pid,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRep,extra3:event.meta.appointment.branch}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../appointment-details', { extra:event.meta.appointment.pid, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch,extra4:event.meta.appointment.timeIn }], { relativeTo: this.actroute });
}
}





unassignSalesRep(){
  this.appointmentForm.patchValue({
salesRepID:"",
  });

}

colorForRep(salesRep){
  if(salesRep=='Nicolas Salazar'){
    this.color=colors.darkgray;
  }else if(salesRep=='Sonia Garofolo'){
    this.color=colors.yellow;
  } else if(salesRep=='Nancy Ventura'){
    this.color=colors.purple;
  }else if(salesRep=='Olivia Dobrovich'){
    this.color=colors.pink;
  } else if(salesRep=='Jason Branco'){
    this.color=colors.green;
  }else if(salesRep=='Ryan Li'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Caelyn Huang'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Alyssa Vani'){
    this.color=colors.info;
  } else if(salesRep=='Alex Karlee Lafarciola'){
    this.color=colors.brightblue;
  }else if(salesRep=='Magdalena Wojtachnio'){
    this.color=colors.orange;
  } else if(salesRep=='Christelle Aniceto'){
    this.color=colors.lightgray;
  }else if(salesRep=='Zach Cannarozzo'){
    this.color=colors.blue;
  } else if(salesRep=='Alexia Rupolo'){
    this.color=colors.brown;
  }else if(salesRep=='Sandra Arango'){
    this.color=colors.red;
  } else if(salesRep=='Lauren Richardson'){
    this.color=colors.coralred;
  }else {
    this.color=colors.black;
  }

}




isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}

}




